<template>
  <div>
    <!-- MODO TELA NORMAL -->
    <div v-if="!printMode">
      <h6>Tabela de valores de planos</h6>
      <p></p>
      <div class="row mb-3">
        <div class="col-auto align-self-end">
          <button class="btn btn-primary" @click="abrirPrint">
            Executar
          </button>
        </div>
      </div>
    </div>

    <!-- MODO PRINT -->
    <div v-else class="relatorio-body" :data-user="props.userName">
      <div v-if="loading">Carregando…</div>

      <div v-else-if="linhas.length">
        <h6>Tabela de valores de planos</h6>

        <table class="table table-striped">
          <thead>
            <tr>
              <th style="width: 6%;">#</th>
              <th style="width: 22%;">Categoria</th>
              <th style="width: 22%;">Tipo de Plano</th>
              <th style="width: 12%;" class="text-center">Aulas/Semana</th>
              <th style="width: 12%;" class="text-center">Nº Parcelas</th>
              <th style="width: 13%;" class="text-end">Parcela</th>
              <th style="width: 13%;" class="text-end">Total</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, idx) in linhas" :key="'plano-' + idx">
              <td>{{ idx + 1 }}</td>
              <td>{{ item.categoria }}</td>
              <td>{{ item.tipo_plano }}</td>
              <td class="text-center">{{ item.aulas_semana }}</td>
              <td class="text-center">{{ item.quantidade_parcelas }}</td>
              <td class="text-end">{{ formatarMoeda(item.valor_parcela) }}</td>
              <td class="text-end">{{ formatarMoeda(item.total) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-else>
        <p class="text-muted">Nenhum plano encontrado.</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import axios from '@/services/axios'
import globalUtils from '@/utils/globalUtils.js'

const props = defineProps({
  printMode:  { type: Boolean, default: false },
  printTitle: { type: String, default: 'Relatório' },
  userName:   { type: String, default: '' }
})

const router  = useRouter()
const loading = ref(false)
const linhas  = ref([])

async function carregarDados () {
  loading.value = true
  try {
    const res = await axios.get('/gestao/relatorios/operacionais/tabela-valores-planos')
    linhas.value = Array.isArray(res.data) ? res.data : []
  } catch (e) {
    console.error('Erro em TabelaValoresPlanos (print):', e)
    linhas.value = []
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  if (props.printMode) {
    carregarDados()
  }
})

function abrirPrint () {
  router.push({
    path: '/gestao/relatorios/print/tabela-valores-planos',
    query: {
      title: 'Tabela de valores de planos'
    }
  })
}

function formatarMoeda (valor) {
  // usa util do seu projeto, mas deixa fallback seguro
  if (globalUtils?.formatarMoeda) return globalUtils.formatarMoeda(valor)
  const n = Number(valor || 0)
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}
</script>

<style scoped>
.mb-3 { margin-bottom: 1rem; }
.text-center { text-align: center !important; }
.text-end { text-align: right !important; }
</style>
